import React from 'react';
import { withFormsy } from 'formsy-react';

import { AdminInput } from './Inputs';
import { Image } from '../base/Elements';

class _AdminImageInput extends React.Component {
  state = {
    value: null
  }

  onChange = (name, value) => {
    this.setState({value: value});
    this.props.setValue(value);
  }

  render() {
    const value = this.state.value || this.props.value;
    const { logo, placeholder } = this.props;

    return (
      <div>
        <AdminInput name="logoUri" label={logo} placeholder={placeholder}
                    value={value||''} validations="isUrl" showErrors onBlur={this.onChange} />

        {value ?
          <img src={value} alt="logo" /> :
          <Image src="/images/logo_placeholder.gif" alt="logo" />
        }
      </div>
    );
  }
};

export const AdminImageInput = withFormsy(_AdminImageInput);
